import { FormFieldDefinition } from '../../../../../../generic/universal-table/types/form.types'
import { IWarehouseLocation } from '../../../../../../modules/API/Warehouse/models/locations'
import { LOCATION_TYPE_OPTIONS, toLocationType } from '../../../../../../generic/artcoded/locationType'

export const locationControlFormFields: FormFieldDefinition<IWarehouseLocation>[] = [
  {
    name: 'CodeLocation',
    label: 'קוד איתור',
    inputType: 'text',
    required: true,
    placeholder: 'הזן קוד איתור',
    validationRules: {
      required: true,
      minLength: 1,
      maxLength: 20,
    },
  },
  {
    // getOptions is injected in LocationControl.tsx
    name: 'WarehouseID',
    label: 'מחסן',
    inputType: 'searchable-select',
    required: true,
    validationRules: {
      required: true,
    },
  },
  {
    // getOptions is injected in LocationControl.tsx; RoomNum 0 is a valid value.
    name: 'Room',
    label: 'חדר',
    inputType: 'searchable-select',
    required: false,
  },
  {
    name: 'Line',
    label: 'שורה',
    inputType: 'text',
    required: false,
    validationRules: {
      maxLength: 20,
    },
  },
  {
    // No default: rows from before the backend rollout (missing / null type) must be picked explicitly.
    name: 'LocationType',
    label: 'סוג איתור',
    inputType: 'select',
    required: true,
    placeholder: 'בחר סוג איתור',
    options: LOCATION_TYPE_OPTIONS,
    transformIn: toLocationType,
    validationRules: {
      required: true,
    },
  },
  {
    // Hidden in create mode — the server creates the row active by default.
    name: 'Active',
    label: 'פעיל',
    inputType: 'boolean-select',
    required: false,
    defaultValue: true,
  },
]
